import { render, staticRenderFns } from "./DropdownDivider.vue?vue&type=template&id=1bab64d0&scoped=true&"
import script from "./DropdownDivider.vue?vue&type=script&lang=js&"
export * from "./DropdownDivider.vue?vue&type=script&lang=js&"
import style0 from "./DropdownDivider.vue?vue&type=style&index=0&id=1bab64d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab64d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bab64d0')) {
      api.createRecord('1bab64d0', component.options)
    } else {
      api.reload('1bab64d0', component.options)
    }
    module.hot.accept("./DropdownDivider.vue?vue&type=template&id=1bab64d0&scoped=true&", function () {
      api.rerender('1bab64d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/ui/dropdown/DropdownDivider.vue"
export default component.exports